import React, { useContext, useEffect, useState, Fragment } from 'react';
import ResultsQuestion from 'chameleon-src/components/results/resultsQuestions';
import { ResultsContext } from 'chameleon-src/components/results/ResultsDataProvider';
import PageTitle from 'legacy/src/components/PageTitle';

const SingleStudentPerformanceOverview = (props) => {
  const resultsData = useContext(ResultsContext);
  const {
    studentId,
    params,
    routes,
    questions,
    learnosityReportsByItemData,
    learnosityReportsByRubricData,
    subjectData,
    location,
    me: meQuery,
    isStudent,
    showResults,
  } = resultsData;
  const { assignment } = props;

  const { studentId: queryStudentId } = params;
  const { me } = meQuery;
  const currentStudentId = queryStudentId || studentId || me.initId;
  const { name: subjectName } = subjectData;

  const [pageTitle, setPageTitle] = useState(null);

  useEffect(() => {
    if (assignment && subjectName) {
      setPageTitle(`${subjectName} ${assignment.title} Report Details`);
    }
  }, [assignment, subjectName]);

  return (
    <Fragment>
      {pageTitle && <PageTitle titleString={pageTitle} />}
      <ResultsQuestion
        showSingleResults
        learnosityReportsByItemData={learnosityReportsByItemData}
        learnosityReportsByRubricData={learnosityReportsByRubricData}
        items={questions}
        itemRoute="SingleStudentPerformanceItem"
        params={params}
        currentStudentId={currentStudentId}
        routes={routes}
        subjectData={subjectData}
        location={location}
        isStudent={isStudent}
        showResults={showResults}
        {...props}
      />
    </Fragment>
  );
};

export default SingleStudentPerformanceOverview;
